import milestones from '~/pages/milestones/shared';

export default milestones;



// WEBPACK FOOTER //
// ./pages/projects/milestones/index/index.js